import { render, staticRenderFns } from "./EntityFormConfigForm.vue?vue&type=template&id=2263343d"
import script from "./EntityFormConfigForm.vue?vue&type=script&lang=js"
export * from "./EntityFormConfigForm.vue?vue&type=script&lang=js"
import style0 from "./EntityFormConfigForm.vue?vue&type=style&index=0&id=2263343d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports